module.exports = __webpack_public_path__ + "static/media/ExperiencingAbstractInformation.d5a77e6a.mov";